import { roles } from '/constants';
import env from '/env';
import { getRealm } from '/utils/host';
const toolbar = '&:toolbar=no';

const appSettings = {

  getAuthCookieName: () => {
    const isDevEnv = env.APP_ENV === 'development';
    return isDevEnv ? 'xyz_los_token': `${getRealm()}_los_token`;
  },
  getLocalTokenName: () => {
    return 'local_jwt_token';
  },
  getTestToken: (role) => {
    switch (role) {
      case roles.ADMIN:
        return 'REPLACE_ME_WITH_VALID_JWT_UI_TOKEN';      
      case roles.CA:
        return '';
      case roles.LO:
        return '';

      case roles.PM:
        return '';

      case roles.CCO:
        return '';

      case roles.CLO:
        return '';

      default:
        return 'unknown----garbage-token-that-will-be-null-if-decoded';
    }
  },
}

if (env.APP_ENV === 'development') {
  window.__LOS__settings = appSettings
}

export default appSettings;